import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setFilters } from '@store/common/action';
import { getCommonFilters } from '@store/reducers';

const MaterialName = ({ onHide, type, refMaterialSearchName }) => {
	const [isSearchDone, setIsSearchDone] = useState(false);
	const [searchValue, setSearchValue] = useState('');
	const dispatch = useDispatch();
	const commonFilters = useSelector(getCommonFilters);

	useEffect(() => {
		dispatch(setFilters({ ...commonFilters, nitexReferenceNumber: searchValue }));
	}, [searchValue]);
	const onKeyPressUpdate = (event) => {
		if (event.key === 'Enter' && !isSearchDone) {
			setSearchValue(event.target.value);
			setIsSearchDone(true);
		}
	};
	return (
		<div className="search-filter material-search-filter">
			<div className="with-icon right-icon" onClick={(e) => e.stopPropagation()}>
				<input
					ref={refMaterialSearchName}
					type="text"
					autoComplete="off"
					placeholder="Material name & no"
					onChange={() => {
						if (isSearchDone) setIsSearchDone(false);
					}}
					onBlur={(e) => {
						if (!isSearchDone) {
							setSearchValue(e.target.value);
						}
					}}
					onKeyDown={(event) => onKeyPressUpdate(event)}
				/>
				{type !== 'PINNED' && type !== 'MATCHING' && (
					<span
						className="right-icon"
						onClick={(e) => {
							e.stopPropagation();
							onHide();
						}}
					>
						<img src={`${process.env.PUBLIC_URL}/icons/Filter-material.svg`} alt="filter" />
					</span>
				)}
				<span className="left-icon">
					<img src={`${process.env.PUBLIC_URL}/icons/search.png`} alt="search" />
				</span>
			</div>
		</div>
	);
};

export default MaterialName;
